class Web {
  static exps = null;

  static W = (path) => {
    Web.exps = Web.exps || (window.site_config || {}).web || {};

    var value = Web.exps;

    path.split('.').forEach(function (p) { if (value != null) value = value[p]; });

    if (path == "wheel_image_map") {
      return value || "https://images.cerchigomme.it/";
    }

    return value;
  }
}

export { Web };